import { render } from "./Facturas.vue?vue&type=template&id=56133a99"
import script from "./Facturas.vue?vue&type=script&lang=js"
export * from "./Facturas.vue?vue&type=script&lang=js"
script.render = render

export default script